<template>
<div>
  <v-flex
    xs12
    d-flex
    justify-center
    class="text-center mt-10">
    <div class="text-center text-xs-left subtitle-1">
        This Tool was created to serve the Strategic Partnership between The International Code Council and the U.S. Department of Commerce International Trade Administration, with support from the International Business Development team at George Mason University.
    </div>
  </v-flex>
  <v-flex
  class="d-flex justify-center pb-2"
  >
    <v-img
      :src="require('@/assets/frontend/components/footer/ITA-logo.jpg.webp')"
      max-height="120"
      max-width="300"
      :aspect-ratio="16/9"
      contain
      class="mt-2 mt-4 ml-5"
    >
    </v-img>
    <v-img
      id="mason"
      :src="require('@/assets/frontend/components/footer/Mason-logo.jpg.webp')"
      :max-height="$vuetify.breakpoint.xs ? 76 : 115"
      max-width="200"
      :aspect-ratio="16/9"
      contain
      position="left center"
      class=" ml-5"
      :class="$vuetify.breakpoint.xs ? 'mt-5' : 'mt-2'"
    >
    </v-img>
  </v-flex>
</div>
</template>

<script>
export default {

}
</script>
